import { DATE_FORMAT } from "../../constants";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  Typography,
  Grid,
} from "@material-ui/core";
import React, { useContext } from "react";

import { LangContext } from "../../context/LangContext";

import moment from "moment";
import translations from "../../assets/json/translations.json";
import { PatientCancerScreeningInfo } from "../../models/getCancerScreeningInfoModel";
import theme from "../../theme";

interface IProps {
  patientInfo: PatientCancerScreeningInfo;
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),

    marginTop: theme.spacing(2),
    "& th": {
      fontWeight: 600,
      fontSize: 15,
    },
    "& td": {
      color: theme.palette.text.secondary,
      fontSize: 15,
    },
  },
  testContainer: {
    "& th": {
      fontWeight: 600,
      fontSize: 12,
      padding: 2,
    },
    "& td": {
      color: theme.palette.text.secondary,
      fontSize: 12,
      padding: 2,
    },
  },
}));

const CancerScreeningInfo: React.FC<IProps> = ({ patientInfo }) => {
  const classes = useStyles({});
  const [lang] = useContext(LangContext);

  return (
    <Paper elevation={2} className={classes.container}>
      <Grid
        container
        justify="space-between"
        style={{ marginBottom: theme.spacing(2) }}
      >
        <Grid item>
          <Typography variant="h5">Komusaga</Typography>
        </Grid>
        <Grid item xs={6}>
          <TableContainer className={classes.testContainer}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Legháls</TableCell>
                  <TableCell>Brjóst</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {patientInfo.status?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {item.translationKey}
                    </TableCell>
                    <TableCell>{item.cervix}</TableCell>
                    <TableCell>{item.breast}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {patientInfo.visits?.length ? (
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{translations.day[lang]}</TableCell>
                <TableCell>{translations.type[lang]}</TableCell>
                <TableCell>{translations.result[lang]}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {patientInfo.visits.map((info, index) => (
                <TableRow hover key={index}>
                  <TableCell>
                    {info.date && moment(info.date).format(DATE_FORMAT)}
                  </TableCell>
                  <TableCell>{info.type}</TableCell>
                  <TableCell>{info.resultHtml}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography
          color="textSecondary"
          style={{ marginTop: theme.spacing(2) }}
        >
          {translations.noDataFound[lang]}
        </Typography>
      )}
    </Paper>
  );
};

export default CancerScreeningInfo;
